import React from 'react';
import PropTypes from 'prop-types';
import dumbBem from 'dumb-bem';
import tx from 'transform-props-with';
import Appear from 'components/common/reactAppear';

import {
  ContentBullet,
  Content,
  Block,
} from 'components/landing/components';

import { Perk } from './Perk';
import './Careers.css';

const dumbCareers = dumbBem('l-careers');
const Perks = tx([{ element: 'perks' }, dumbCareers])('div');

const PerksList = ({
  perksRef,
  title,
  perks,
}) => {
  return (
    <Block modifier="content" __ref={perksRef}>
      <ContentBullet title={title} />

      <Content modifier="content">
        <Perks>
          {perks.map((perk, id) => (
            <Appear className="l-careers appear-animation" key={id}>
              <Perk {...perk} />
            </Appear>
          ))}
        </Perks>
      </Content>
    </Block>
  );
};

PerksList.propTypes = {
  perksRef: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
  perks: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    icon: PropTypes.string.isRequired,
  })).isRequired,
};

export default PerksList;



// WEBPACK FOOTER //
// ./src/components/landing/pages/careers/PerksList.jsx